import { useEffectOnce } from 'react-use';
import { useCXI } from 'modules/cxi/useCXI';

export const MentoringSession = () => {
    const { modal, setModal } = useCXI();
    const { match } = modal;

    useEffectOnce(() => {
        setModal({ match, modal: 'MentoringSessionForm' });
    }, []);

    return null;
};
